//
// Room
//

import { z } from "zod";
import { Entity } from "../../common/entity";
import { DbCreateInputOmit, DbUpdate } from "../../helpers/db";

export const WorkspaceRoom = Entity.extend({
  workspaceId: z.string(),
  liveblocksId: z.string(),
});

export type WorkspaceRoom = z.infer<typeof WorkspaceRoom>;
export type CreateWorkspaceRoom = DbCreateInputOmit<WorkspaceRoom>;
export type UpdateWorkspaceRoom = DbUpdate<WorkspaceRoom>;
